import React, { useState, useRef, useEffect } from 'react';
import cx from 'classnames';
import '../../ui/accordions/Accordion/index.js';
import '../../ui/accordions/AccordionSelect/index.js';
import '../../ui/badges/Badge/index.js';
import '../../ui/badges/BadgeIcon/index.js';
import '../../ui/badges/Checked/index.js';
import '../../ui/badges/Panel/index.js';
import '../../ui/badges/Status/index.js';
import '../../ui/badges/Tag/index.js';
import '../../ui/buttons/BabyButton/Base.js';
import '../../ui/buttons/BabyButton/variants/Chat/index.js';
import '../../ui/buttons/BabyButton/variants/Menu/index.js';
import '../../ui/buttons/BabyButton/variants/User/index.js';
import '../../ui/buttons/BabyButton/variants/Vip/index.js';
import '../../ui/buttons/BabyButton/variants/Wallet/index.js';
import { Button } from '../../ui/buttons/Button/index.js';
import '../../ui/buttons/CloseButton/index.js';
import '../../ui/buttons/DirectionButton/index.js';
import '../../ui/buttons/GradientButton/index.js';
import '../../ui/buttons/GradientButtonV2/index.js';
import '../../ui/buttons/TabButton/index.js';
import '../../ui/buttons/TabButtonV2/index.js';
import '../../ui/buttons/TimerButton/index.js';
import '../../ui/buttons/TimerButtonV2/index.js';
import '../../ui/buttons/TimerButtonV3/index.js';
import '../../ui/loaders/Loader/index.js';
import '../../ui/loaders/ScreenLoader/index.js';
import '../../ui/modals/Modal/MobileWrapperV2/index.js';
import '../../ui/modals/Modal/Modal.js';
import '../../ui/modals/Modal/ModalContentWrapper/index.js';
import '../../ui/popups/Popper/index.js';
import '../../ui/popups/Popup/BasePopup/index.js';
import '../../ui/popups/Popup/Thumb/index.js';
import '../../ui/popups/Popup/ThumbV2/index.js';
import '../../ui/popups/Popup/InfoTooltip/index.js';
import '../../ui/sliders/EmblaCarousel/index.js';
import '../../ui/tables/Table/index.js';
import '../../ui/tables/Table/TableTd/index.js';
import '../../ui/tabs/Tabs/index.js';
import '../../ui/tabs/TabsV2/index.js';
import '../../ui/texts/CryptoValue/index.js';
import '../../ui/texts/AmountValue/index.js';
import '../../ui/texts/TitleWithCurrency/index.js';
import '../../ui/texts/Text/index.js';
import '../../ui/texts/TextNavigation/index.js';
import '../../ui/texts/MinValue/index.js';
import '../../ui/socials/SocialsList/index.js';
import '../../common/DateFormat/index.js';
import '@anton.bobrov/react-hooks';
import '@anton.bobrov/react-components';
import '../../common/GradientWrapper/index.js';
import { Icon } from '../../common/Icon/index.js';
import '../../common/LazyImage/index.js';
import '../../common/NumberFormat/index.js';
import '../../common/WithCustomScrollbar/index.js';
import styles from './index.module.scss.js';

const preventEvent = (e) => {
  e.preventDefault();
  e.stopPropagation();
};
const FileUploader = ({
  id,
  file,
  setFile = () => {
  },
  onChange = () => {
  },
  onTypeError = () => {
  },
  fileTypes = ".jpg, .jpeg, .png, .webp",
  title,
  description,
  successUploaded,
  multiple,
  simpleView,
  text = {
    uploadButton: "Choose File"
  },
  className,
  style,
  ...props
}) => {
  const [error, setError] = useState("");
  const [isDragOver, setIsDragOver] = useState(false);
  const fileInput = useRef(null);
  const uploadFiles = async (files) => {
    const firstValidFile = files?.find(
      (item) => fileTypes?.includes(item.name?.split(".")?.pop()?.toLowerCase() || "")
    );
    if (!firstValidFile) {
      setError("error");
      onTypeError();
      if (fileInput.current) {
        fileInput.current.value = "";
      }
      setFile(null);
      return;
    }
    setError(null);
    setFile(firstValidFile);
    onChange(firstValidFile);
  };
  const dropHandler = async (event) => {
    preventEvent(event);
    setIsDragOver(false);
    const files = [];
    if (event.dataTransfer.items) {
      const arr = [...event.dataTransfer.items];
      arr.forEach((item) => {
        if (item.kind === "file") {
          files.push(item.getAsFile());
        }
      });
    } else {
      const arr = [...event.dataTransfer.files];
      arr.forEach((item) => {
        files.push(item);
      });
    }
    uploadFiles(files);
  };
  const handleChange = (event) => {
    preventEvent(event);
    uploadFiles(Array.from(event.target.files || []));
  };
  const clickHandler = () => {
    fileInput?.current?.click();
  };
  useEffect(() => {
    if (!file) {
      if (fileInput.current) {
        fileInput.current.value = "";
      }
    }
  }, [file]);
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: cx(styles.box, className, "file-uploader", {
        [styles["simple-view"]]: !!simpleView
      }),
      style,
      ...props
    },
    /* @__PURE__ */ React.createElement(
      "div",
      {
        className: cx(styles.area, "file-uploader__area", {
          [styles.error]: !!error,
          [styles["drag-on"]]: !!isDragOver
        }),
        onDragOver: (e) => {
          preventEvent(e);
          setIsDragOver(true);
        },
        onDragEnter: (e) => {
          preventEvent(e);
          setIsDragOver(true);
        },
        onDragLeave: (e) => {
          preventEvent(e);
          setIsDragOver(false);
        },
        onDrop: dropHandler,
        onClick: clickHandler,
        onKeyDown: (e) => {
          if (e.key === "Enter") {
            clickHandler?.();
          }
        },
        role: "button",
        tabIndex: 0
      },
      /* @__PURE__ */ React.createElement(
        "input",
        {
          type: "file",
          ref: fileInput,
          onChange: handleChange,
          accept: fileTypes,
          multiple: false,
          "aria-label": "file-input"
        }
      ),
      /* @__PURE__ */ React.createElement("div", { className: cx(styles.info, "file-uploader__info") }, /* @__PURE__ */ React.createElement(Icon, { iconName: "PhotoUp" }), /* @__PURE__ */ React.createElement("div", { className: cx(styles.title) }, file ? file.name : title), /* @__PURE__ */ React.createElement("div", { className: cx(styles.description) }, description))
    ),
    !simpleView && /* @__PURE__ */ React.createElement(
      Button,
      {
        className: cx(styles["styled-button"], "file-uploader__button"),
        size: "medium-3",
        themeKind: "dark-blue",
        text: text.uploadButton,
        icon: /* @__PURE__ */ React.createElement(Icon, { iconName: "Upload" }),
        onClick: clickHandler
      }
    ),
    simpleView && /* @__PURE__ */ React.createElement(
      "button",
      {
        type: "button",
        className: cx(
          styles["simple-button"],
          "file-uploader__simple-button"
        ),
        onClick: clickHandler,
        "aria-label": "add-file"
      },
      /* @__PURE__ */ React.createElement(Icon, { iconName: "PlusIcon" })
    )
  );
};
FileUploader.displayName = "FileUploader";

export { FileUploader };
//# sourceMappingURL=index.js.map
